/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Event_End_DescInputs */

const en_snap_to_event_end_desc = /** @type {(inputs: Snap_To_Event_End_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snap event start times to the end of the previous event when within 0.5 seconds`)
};

const fr_snap_to_event_end_desc = /** @type {(inputs: Snap_To_Event_End_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aligner le début des événements sur la fin du précédent dans un rayon de 0,5 secondes`)
};

const de_snap_to_event_end_desc = /** @type {(inputs: Snap_To_Event_End_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snap-Ereignisstartzeiten auf das Ende des vorherigen Ereignisses setzen, wenn sie innerhalb von 0,5 Sekunden liegen`)
};

const it_snap_to_event_end_desc = /** @type {(inputs: Snap_To_Event_End_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggancia gli orari di inizio degli eventi alla fine dell'evento precedente quando mancano 0,5 secondi`)
};

const ru_snap_to_event_end_desc = /** @type {(inputs: Snap_To_Event_End_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Совместите время начала события с концом предыдущего события, если разница составляет не более 0,5 секунды.`)
};

const es_snap_to_event_end_desc = /** @type {(inputs: Snap_To_Event_End_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar los tiempos de inicio del evento al final del evento anterior cuando estén dentro de 0,5 segundos`)
};

const zh_cn2_snap_to_event_end_desc = /** @type {(inputs: Snap_To_Event_End_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快照事件的开始时间与前一个事件的结束时间之间的时间间隔应在 0.5 秒以内。`)
};

const ja_snap_to_event_end_desc = /** @type {(inputs: Snap_To_Event_End_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0.5秒以内の場合、イベントの開始時間を前のイベントの終了時間にスナップします。`)
};

const hi_snap_to_event_end_desc = /** @type {(inputs: Snap_To_Event_End_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यदि प्रारंभ समय और पिछले प्रारंभ समय के बीच 0.5 सेकंड का अंतर हो, तो स्नैप इवेंट प्रारंभ समय को पिछले इवेंट के समाप्ति समय से जोड़ें।`)
};

const pt_pt2_snap_to_event_end_desc = /** @type {(inputs: Snap_To_Event_End_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar os horários de início dos eventos para o final do evento anterior quando a diferença for inferior a 0,5 segundos.`)
};

/**
* | output |
* | --- |
* | "Snap event start times to the end of the previous event when within 0.5 seconds" |
*
* @param {Snap_To_Event_End_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_event_end_desc = /** @type {((inputs?: Snap_To_Event_End_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Event_End_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snap_to_event_end_desc(inputs)
	if (locale === "de") return de_snap_to_event_end_desc(inputs)
	if (locale === "it") return it_snap_to_event_end_desc(inputs)
	if (locale === "ru") return ru_snap_to_event_end_desc(inputs)
	if (locale === "es") return es_snap_to_event_end_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_snap_to_event_end_desc(inputs)
	if (locale === "ja") return ja_snap_to_event_end_desc(inputs)
	if (locale === "hi") return hi_snap_to_event_end_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_snap_to_event_end_desc(inputs)
	return en_snap_to_event_end_desc(inputs)
});